<footer class="app-footer" role="contentinfo">
  <div class="app-footer__inner">
    <div class="app-footer__left">
      @if (showPoweredBy()) {
      <span class="app-footer__text">Powered by</span>

      @if (companyUrl(); as url) {
      <a class="app-footer__brand" [href]="url" target="_blank" rel="noopener noreferrer">
        {{ companyName() }}
      </a>
      } @else {
      <span class="app-footer__brand">{{ companyName() }}</span>
      } }
    </div>

    <div class="app-footer__right">
      @if (showCopyright()) {
      <span class="app-footer__text"> © {{ companyName() }} {{ year }}. All rights reserved. </span>
      }
    </div>
  </div>
</footer>
